import React from 'react';
import { Card, CardContent, Typography } from '@mui/material';
import { COLOR_GREY_600 } from 'src/utils/colors';

interface UsageMetricCardProps {
  title: string;
  value: string;
}

const UsageMetricCard: React.FC<UsageMetricCardProps> = ({ title, value }) => {
  return (
    <Card sx={{ borderRadius: 2, boxShadow: 2, height: '100%', p: 1 }}>
      <CardContent>
        <Typography variant="body2" sx={{ color: COLOR_GREY_600, fontWeight: 500, mb: 1 }}>
          {title}
        </Typography>
        <Typography variant="h2" sx={{ fontWeight: 600, color: 'text.primary' }}>
          {value}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default UsageMetricCard;
